import { withProcedureWraper } from "../../../../..";
import { Error, Loading } from "../../../../../../../components";

import { useAFLRequest } from "../../../hooks";

import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateApplicationForLeaveForm } from "../../../components";

const dataFallback = {};

const AbsenceLetterEdit = withProcedureWraper(() => {
  const {
    data = dataFallback,
    isLoading: isRequestLoading,
    isFetching: isRequestFetching,
    isError,
  } = useAFLRequest();

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;

  return (
    <ProcedureLayout
      title="Chỉnh sửa đơn xin nghỉ phép"
      loading={isRequestFetching}
    >
      <CreateApplicationForLeaveForm data={data} />
    </ProcedureLayout>
  );
});

export default AbsenceLetterEdit;
